<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item label="导入时间：">
              <el-date-picker style="width:193px;" v-model="form.month" value-format="yyyy-MM" type="month" placeholder="选择月"></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace2" @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="导入时间：">
              <el-date-picker style="width:193px;" v-model="form1.month" value-format="yyyy-MM" type="month" placeholder="选择月"> </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:`${api}/report`,data:form1,callback:_d=>tableData1=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('tyjryb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._m"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
    </div>
    <el-button type="primary" v-if="showBtn[5].isShow" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button
        type="primary" v-show="admin" v-loading.fullscreen.lock="lodaingTime"
        @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table :data="tableData" border max-height="550" @selection-change="handleSelectionChange" style="width: 99.9%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column show-overflow-tooltip v-for="(item,index) in baseInfo" :key="index" :prop="item.key" :label="item.value" align="center"></el-table-column>
        <el-table-column align="center" label="报告期期初数">
          <el-table-column v-for="(o,i) in tow" :key="i+'index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="就业援助情况">
          <el-table-column v-for="(o,i) in tow" :key="i+'2index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期累计实现就业数">
          <el-table-column v-for="(o,i) in three" :key="i+'index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期累计新增数">
          <el-table-column v-for="(o,i) in four" :key="i+'index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期期末数">
          <el-table-column v-for="(o,i) in five" :key="i+'index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column v-for="(o,i) in six" :key="i+'index1'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <div class="table" v-show="out">
      <el-table :data="tableData1" max-height="550" border @selection-change="handleSelectionChange" style="width: 99.9%">
        <el-table-column show-overflow-tooltip v-for="(o,i) in baseInfo1" :key="i" :prop="o.key" :label="o.value" align="center"></el-table-column>
        <el-table-column align="center" label="报告期期初数">
          <el-table-column v-for="(o,i) in tow" :key="i+'index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="就业援助情况">
          <el-table-column v-for="(o,i) in tow" :key="i+'2index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期累计实现就业数">
          <el-table-column v-for="(o,i) in three" :key="i+'index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期累计新增数">
          <el-table-column v-for="(o,i) in four" :key="i+'index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="报告期期末数">
          <el-table-column v-for="(o,i) in five" :key="i+'index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center"></el-table-column>
        </el-table-column>
        <el-table-column v-for="(o,i) in six" :key="i+'index2'" show-overflow-tooltip :prop="o.key" :label="o.value" align="center">
        </el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number = 'get_page_number'></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog title="退役军人月报管理" :visible.sync="centerDialogVisible" :modal="false" @close="close" width="1400px" :close-on-click-modal="false" center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" :rules="rules" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <!-- <el-form-item label="辖区内国有独立工矿企业个数：">
                          <el-input style="width:193px;" v-model="editForm.organizationCount"></el-input>
                        </el-form-item> -->
                        <el-form-item label="失业人员总人数：">
                          <el-input style="width:193px;" v-model="editForm.lastUnworkCount"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员总人数(女)：">
                          <el-input style="width:193px;" v-model="editForm.lastUnworkFemaleCount"></el-input>
                        </el-form-item>
                        <el-form-item label="提供岗位数：">
                          <el-input style="width:193px;" v-model="editForm.needPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="职业指导次数：">
                          <el-input style="width:193px;" v-model="editForm.careerHelpCount"></el-input>
                        </el-form-item>
                        <el-form-item label="职业介绍次数：">
                          <el-input style="width:193px;" v-model="editForm.introduceHelpCount"></el-input>
                        </el-form-item>
                        <el-form-item label="培训人数：">
                          <el-input style="width:193px;" v-model="editForm.trainingCount"></el-input>
                        </el-form-item>
                        <el-form-item label="创业培训人数：">
                          <el-input style="width:193px;" v-model="editForm.pioneerTrainingCount"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="失业人员已就业人数：">
                          <el-input style="width:193px;" v-model="editForm.currentHaveJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="自主创业：">
                          <el-input style="width:193px;" v-model="editForm.currentPioneerCount"></el-input>
                        </el-form-item>
                        <el-form-item label="单位吸纳：">
                          <el-input style="width:193px;" v-model="editForm.currentOrganizationCount"></el-input>
                        </el-form-item>
                        <el-form-item label="灵活就业：">
                          <el-input style="width:193px;" v-model="editForm.currentFlexibleJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="公益性岗位安置：">
                          <el-input style="width:193px;" v-model="editForm.currentPublicWelfareJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="其它：">
                          <el-input style="width:193px;" v-model="editForm.currentOtherCount"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员累计新增数：">
                          <el-input style="width:193px;" v-model="editForm.currentAddUnwork"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员累计新增数(女)：">
                          <el-input style="width:193px;" v-model="editForm.currentAddFemaleUnwork"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员期末数：">
                          <el-input style="width:193px;" v-model="editForm.nowUnworkCount"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员期末数(女)：">
                          <el-input style="width:193px;" v-model="editForm.nowUnworkFemaleCount"></el-input>
                        </el-form-item>
                        <el-form-item label="导入时间：">
                          <el-date-picker style="width:193px;" v-model="editForm.month" value-format="yyyy-MM" type="month" placeholder="选择月"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api:'/user/retireSoldier',
      form:{},
      type:'31',
      centerDialogVisible:false,
      tableData1:[],
      tableData:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
      ],
      baseInfo1:[
        {key: 'areaName', value: '市州'},
      ],
      tow:[
        // {key:'organizationCount',value:'辖区内国有独立工矿企业个数'},
        {key:'lastUnworkCount',value:'失业人员总人数'},
        {key:'lastUnworkFemaleCount',value:'失业人员总人数(女)'},
      ],
      three:[
        {key:'needPersons',value:'提供岗位数'},
        {key:'careerHelpCount',value:'职业指导次数'},
        {key:'introduceHelpCount',value:'职业介绍次数'},
        {key:'trainingCount',value:'培训人数'},
        {key:'pioneerTrainingCount',value:'创业培训人数'},
      ],
      four:[
        {key:'currentHaveJobCount',value:'失业人员已就业人数'},
        {key:'currentPioneerCount',value:'自主创业'},
        {key:'currentOrganizationCount',value:'单位吸纳'},
        {key:'currentFlexibleJobCount',value:'灵活就业'},
        {key:'currentPublicWelfareJobCount',value:'公益性岗位安置'},
        {key:'currentOtherCount',value:'其它'},
      ],
      five:[
        {key:'currentAddUnwork',value:'失业人员数'},
        {key:'currentAddFemaleUnwork',value:'失业人员数(女)'},
        {key:'nowUnworkCount',value:'失业人员数'},
        {key:'nowUnworkFemaleCount',value:'失业人员数(女)'},
      ],
      six:[
        {key:'month',value:'导入时间'},
      ],
      rules:{
        socialCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      isCreate:false,
      out:false
    }
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res  => {
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res  => {
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
    //查询列表
    getData() {
      this.$api.getData(this.api,this.form).then(res  => {
        if (res.data.status === 0) {
          this.tableData = JSON.parse(res.data.data)
          this.total = res.data.size
        } else{
          this._status(res.data)
        }
      })
    }
  },
  created() {
    this.isShowBtn("RetireSoldier")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  }
}
</script>

<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}
</style>